import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import applicationSubmitted from "assets/application_submitted.jpg";
import { DataFormsContext } from "context/DataFormsContext";
import { Typography } from "components/Typography";

import { Container, Content, ImageSuccess } from "./ApplicationSubmitted.css";

interface ApplicationSubmittedProps {
  onStartNew?: () => void;
}

export const ApplicationSubmitted = ({
  onStartNew,
}: ApplicationSubmittedProps) => {
  const { t } = useTranslation();
  const { updateData } = useContext(DataFormsContext);

  const onHomeRedirect = () => {
    updateData((_) => null);
    onStartNew?.();
  };

  return (
    <Container>
      <Content>
        <ImageSuccess
          src={applicationSubmitted}
          alt={"successfully submitted"}
        />
        <Typography variant="body">{t("application_received_text")}</Typography>
      </Content>
      <Button onClick={onHomeRedirect} variant="contained" size="large" fullWidth>
        {t("fill_new_application")}
      </Button>
    </Container>
  );
};
